export default "__VITE_ASSET__CghyIv$F__"